//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { IApiRequest } from '../../IApiRequest';

export class RenameGroupRequest extends IApiRequest<void>
{
	public $type = 'RenameGroupRequest';
	constructor(public data: { groupId: string, groupName: string, companyId: string }) { super(); }
}
